import React from "react";
import { Navigate } from "react-router-dom";

import { useAuthState } from "src/features/auth/hooks/useAuthState";
import { useHasPermission } from "src/features/auth/hooks/useHasPermission";
import { Permission } from "src/features/auth/types";

interface AuthorizedProps {
	permission: Permission;
	redirectTo?: string;
}

export const HasPermission: React.FunctionComponent<
	React.PropsWithChildren<AuthorizedProps>
> = ({ permission, redirectTo, children }) => {
	const { isInitialized, isLoading } = useAuthState();
	const isAuthorized = useHasPermission(permission);
	if (isInitialized && !isLoading) {
		if (isAuthorized) {
			return <>{children}</>;
		}
		if (redirectTo) {
			return <Navigate to={redirectTo} />;
		}
	}
	return null;
};
